var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "33px",
    viewBox: "0 0 30 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "date") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.1537594,2.53849624 C18.2668421,2.53849624 17.5472932,1.92789474 17.5472932,1.17315789 C17.5472932,0.776390977 17.7478195,0.42 18.0658647,0.17075188 C18.1348872,0.631578947 18.5923308,0.989548872 19.1537594,0.989548872 C19.7149624,0.989548872 20.1728571,0.631353383 20.2407519,0.16962406 C20.5596992,0.419548872 20.7604511,0.77593985 20.7604511,1.17315789 M1.69962406,2.53849624 C0.811804511,2.53849624 0.0927067669,1.92789474 0.0927067669,1.17315789 C0.0927067669,0.776390977 0.293233083,0.419774436 0.611954887,0.170075188 C0.680300752,0.631353383 1.13774436,0.989548872 1.69917293,0.989548872 C2.26037594,0.989548872 2.71827068,0.631353383 2.78684211,0.170300752 C3.10511278,0.419774436 3.30609023,0.776390977 3.30609023,1.17315789",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.7883027%",
    y1: "46.8960499%",
    x2: "76.2123982%",
    y2: "52.9047357%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2932B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD227",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "0 0.151691729 29.8244887 0.151691729 29.8244887 30.6765789 0 30.6765789"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-6",
    points: "0 0.151691729 29.8244887 0.151691729 29.8244887 6.8193609 0 6.8193609"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-8",
    points: "0 32.2319549 29.8245113 32.2319549 29.8245113 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tom",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "date"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(4.736842, 4.036466)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1537594,2.53849624 C18.2668421,2.53849624 17.5472932,1.92789474 17.5472932,1.17315789 C17.5472932,0.776390977 17.7478195,0.42 18.0658647,0.17075188 C18.1348872,0.631578947 18.5923308,0.989548872 19.1537594,0.989548872 C19.7149624,0.989548872 20.1728571,0.631353383 20.2407519,0.16962406 C20.5596992,0.419548872 20.7604511,0.77593985 20.7604511,1.17315789 C20.7604511,1.92789474 20.0420301,2.53849624 19.1537594,2.53849624 M1.69962406,2.53849624 C0.811804511,2.53849624 0.0927067669,1.92789474 0.0927067669,1.17315789 C0.0927067669,0.776390977 0.293233083,0.419774436 0.611954887,0.170075188 C0.680300752,0.631353383 1.13774436,0.989548872 1.69917293,0.989548872 C2.26037594,0.989548872 2.71827068,0.631353383 2.78684211,0.170300752 C3.10511278,0.419774436 3.30609023,0.776390977 3.30609023,1.17315789 C3.30609023,1.92789474 2.58676692,2.53849624 1.69962406,2.53849624",
    id: "Fill-1",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 1.555263)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8905789,5.01958647 C23.0036617,5.01958647 22.2841128,4.40921053 22.2841128,3.65424812 C22.2841128,2.90086466 23.0036617,2.28890977 23.8905789,2.28890977 C24.7788496,2.28890977 25.4972707,2.90086466 25.4972707,3.65424812 C25.4972707,4.40921053 24.7788496,5.01958647 23.8905789,5.01958647 M6.43666917,5.01958647 C5.54862406,5.01958647 4.82952632,4.40921053 4.82952632,3.65424812 C4.82952632,2.90086466 5.54862406,2.28890977 6.43666917,2.28890977 C7.32381203,2.28890977 8.04290977,2.90086466 8.04290977,3.65424812 C8.04290977,4.40921053 7.32381203,5.01958647 6.43666917,5.01958647 M27.0293008,0.151691729 L2.79358647,0.151691729 C1.25095489,0.151691729 -2.2556391e-05,1.21545113 -2.2556391e-05,2.52642857 L-2.2556391e-05,28.3016165 C-2.2556391e-05,29.6130451 1.25095489,30.6765789 2.79358647,30.6765789 L27.0293008,30.6765789 C28.5730602,30.6765789 29.8244887,29.6130451 29.8244887,28.3016165 L29.8244887,2.52642857 C29.8244887,1.21545113 28.5730602,0.151691729 27.0293008,0.151691729",
    id: "Fill-4",
    fill: "#E4E4E4",
    mask: "url(#mask-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 1.555263)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8905789,5.01958647 C23.0036617,5.01958647 22.2841128,4.40921053 22.2841128,3.65424812 C22.2841128,2.90086466 23.0036617,2.28890977 23.8905789,2.28890977 C24.7788496,2.28890977 25.4972707,2.90086466 25.4972707,3.65424812 C25.4972707,4.40921053 24.7788496,5.01958647 23.8905789,5.01958647 M6.43666917,5.01958647 C5.54862406,5.01958647 4.82952632,4.40921053 4.82952632,3.65424812 C4.82952632,2.90086466 5.54862406,2.28890977 6.43666917,2.28890977 C7.32381203,2.28890977 8.04290977,2.90086466 8.04290977,3.65424812 C8.04290977,4.40921053 7.32381203,5.01958647 6.43666917,5.01958647 M27.0293008,0.151691729 L2.79358647,0.151691729 C1.25095489,0.151691729 -2.2556391e-05,1.21545113 -2.2556391e-05,2.52642857 L-2.2556391e-05,6.8193609 L29.8244887,6.8193609 L29.8244887,2.52642857 C29.8244887,1.21545113 28.5730602,0.151691729 27.0293008,0.151691729",
    id: "Fill-7",
    fill: "#E9382E",
    mask: "url(#mask-7)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#C02026",
    mask: "url(#mask-9)",
    points: "0 10.5836842 29.8245113 10.5836842 29.8245113 8.23015038 0 8.23015038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43655639,3.24327068 C5.15715789,3.24327068 4.12091729,4.12409774 4.12091729,5.20951128 C4.12091729,6.29672932 5.15715789,7.17665414 6.43655639,7.17665414 C7.7146015,7.17665414 8.74993985,6.29672932 8.74993985,5.20951128 C8.74993985,4.12409774 7.7146015,3.24327068 6.43655639,3.24327068",
    id: "Fill-12",
    fill: "#962621",
    mask: "url(#mask-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8914812,3.24327068 C22.611406,3.24327068 21.5760677,4.12409774 21.5760677,5.20951128 C21.5760677,6.29672932 22.611406,7.17665414 23.8914812,7.17665414 C25.1690752,7.17665414 26.2046391,6.29672932 26.2046391,5.20951128 C26.2046391,4.12409774 25.1690752,3.24327068 23.8914812,3.24327068",
    id: "Fill-13",
    fill: "#962621",
    mask: "url(#mask-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53769173,4.0895188 C7.53769173,4.60696241 7.04460902,5.02583459 6.43603759,5.02583459 C5.82746617,5.02583459 5.33483459,4.60696241 5.33483459,4.0895188 L5.33483459,0.936135338 C5.33483459,0.419142857 5.82746617,4.5112782e-05 6.43603759,4.5112782e-05 C7.04460902,4.5112782e-05 7.53769173,0.419142857 7.53769173,0.936135338 L7.53769173,4.0895188 Z",
    id: "Fill-14",
    fill: "#5E3131",
    mask: "url(#mask-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9914887,4.0895188 C24.9914887,4.60696241 24.4988571,5.02583459 23.8905113,5.02583459 C23.2819398,5.02583459 22.7888571,4.60696241 22.7888571,4.0895188 L22.7888571,0.936135338 C22.7888571,0.419142857 23.2819398,4.5112782e-05 23.8905113,4.5112782e-05 C24.4988571,4.5112782e-05 24.9914887,0.419142857 24.9914887,0.936135338 L24.9914887,4.0895188 Z",
    id: "Fill-15",
    fill: "#5E3131",
    mask: "url(#mask-9)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#B2B2B2",
    mask: "url(#mask-9)",
    points: "9.94172932 17.356015 13.9786466 17.356015 13.9786466 13.9256391 9.94172932 13.9256391"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#B2B2B2",
    mask: "url(#mask-9)",
    points: "15.845188 17.3564662 19.8825564 17.3564662 19.8825564 13.9256391 15.845188 13.9256391"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#B2B2B2",
    mask: "url(#mask-9)",
    points: "21.7486466 17.3564662 25.786015 17.3564662 25.786015 13.9256391 21.7486466 13.9256391"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#B2B2B2",
    mask: "url(#mask-9)",
    points: "4.03827068 22.9046617 8.07518797 22.9046617 8.07518797 19.4740602 4.03827068 19.4740602"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#B2B2B2",
    mask: "url(#mask-9)",
    points: "9.94172932 22.9046617 13.9786466 22.9046617 13.9786466 19.4740602 9.94172932 19.4740602"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#EB5D52",
    mask: "url(#mask-9)",
    points: "15.845188 22.9046617 19.8825564 22.9046617 19.8825564 19.4740602 15.845188 19.4740602"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#B2B2B2",
    mask: "url(#mask-9)",
    points: "21.7486466 22.9046617 25.786015 22.9046617 25.786015 19.4740602 21.7486466 19.4740602"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#B2B2B2",
    mask: "url(#mask-9)",
    points: "4.03827068 28.4533083 8.07518797 28.4533083 8.07518797 25.0227068 4.03827068 25.0227068"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#B2B2B2",
    mask: "url(#mask-9)",
    points: "9.94172932 28.4533083 13.9786466 28.4533083 13.9786466 25.0227068 9.94172932 25.0227068"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#B2B2B2",
    mask: "url(#mask-9)",
    points: "15.845188 28.4533083 19.8825564 28.4533083 19.8825564 25.0227068 15.845188 25.0227068"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#B2B2B2",
    mask: "url(#mask-9)",
    points: "21.7486466 28.4533083 25.786015 28.4533083 25.786015 25.0227068 21.7486466 25.0227068"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.5341827c7027aec7cd6e5113ffdeeaac.svg";
export { ForwardRef as ReactComponent };